import IdvSubmitComplete from './idv-submit-complete';

export default IdvSubmitComplete;
